import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronTriangleDownSmall"><Path d="M14.5876 11.8153C14.8531 11.4885 14.6205 11 14.1995 11H9.80049C9.37947 11 9.14694 11.4885 9.41243 11.8153L11.6119 14.5224C11.812 14.7687 12.188 14.7687 12.3881 14.5224L14.5876 11.8153Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronTriangleDownSmall;
